export const consignmentTypeList = [
  { id: 1, name: "Import Open Truck" },
  { id: 2, name: "Export Open Truck" },
];

export const statusList = [
  "Assigned",
  "Cancelled",
  "Completed",
  "Onsite",
  "Unscheduled",
  "Deduction",
];
export const weightUnitList = ["KG"];
export const weightUnitForInspection = ["KG"];
export const dimensionUnitList = ["Meter", "Inch", "Feet"];
export const currencyUnitList = ["PKR"];

export const colorCodeList = [
  { value: 1, name: "Red", backgroundColor: "#dc0a0a" },
  { value: 2, name: "Yellow", backgroundColor: "#d6d623" },
  { value: 3, name: "Blue", backgroundColor: "#3a71cb" },
  { value: 4, name: "Green", backgroundColor: "#62ae00" },
  { value: 5, name: "Black", backgroundColor: "#686868" },
  { value: 6, name: "Orange", backgroundColor: "#e08315" },
  { value: 7, name: "Cyan", backgroundColor: "#00d1d0" },
];

export const supplierTypeList = [
  { value: 1, name: "Importer" },
  { value: 2, name: "Exporter" },
];
export const colorCodeListForGateIn = [
  { value: 1, name: "Red Channel", backgroundColor: "red", textColor: "black" },
  { value: 2, name: "Yellow Channel", backgroundColor: "yellow", textColor: "black" },
  { value: 3, name: "Blue Channel", backgroundColor: "blue", textColor: "white" },
  { value: 4, name: "Green Channel", backgroundColor: "green", textColor: "white" },
  { value: 5, name: "Black Channel", backgroundColor: "black", textColor: "white" },
  { value: 6, name: "Orange Channel", backgroundColor: "orange", textColor: "black" },
  { value: 7, name: "Cyan Channel", backgroundColor: "cyan", textColor: "black" },
];
export const customColorCodeList = [
  { value: 1, name: "Red" },
  { value: 2, name: "Yellow" },
  { value: 3, name: "Blue" },
  { value: 4, name: "Green" },
];
export const colorCodesInventory = [
  { color: "Red", code: "#F80348", bgCode: "#FFDBDB" },
  { color: "Green", code: "#59B75C", bgCode: "#DCFFD9" },
  { color: "Blue", code: "#0465F7", bgCode: "#E0F5FF" },
  { color: "Orange", code: "#FF8800", bgCode: "#FFF0CD" },
];
export const fileCompressionFileTypes = [
  { typeName: ".pdf" },
  { typeName: ".doc" },
  { typeName: ".docx" },
  { typeName: ".xlsx" },
  { typeName: ".jpg" },
  { typeName: ".jpeg" },
  { typeName: ".png" },
];
export const modesOfPayment = ["Cash", "Easypaisa", "Jazz Cash", "Bank Transfer"];
export const travellingDocTypes = ["Passport", "Tazkara", "ID"];
export const containerSIzeList = ["20", "40", "45"];
export const containerQuantity = ["1", "2"];
export const containerTypeList = ["GENERAL", "DG", "LOOSE CARGO"];

/** When terminalType === 4 (Dry Port without Weboc), only LOOSE CARGO and BONDED CARGO are shown. */
export const getContainerTypeList = (terminalType?: number): string[] =>
  terminalType === 4 ? ["LOOSE CARGO", "BONDED CARGO"] : containerTypeList;
export const storageTypeList = [
  "CY40",
  "CY45",
  "CY20",
  "Scrap",
  "CFS Car",
  "CFS LCL(DG)",
  "CFS LCL(General)",
  "CY(DG)45",
  "CY(DG)40",
  "CY(DG)20",
];
export const ExamType = ["Pending", "Completed", "Hold"];
export const StuffDestuffType = ["Stuff", "Destuff"];
export const containerLoadTypeList = ["CFS", "CY", "CFS Scrap"];
export const importerExporterVals = ["Importer", "Exporter"];
export const scannerComments = [
  { comment: "Normal" },
  { comment: "Abnormal" },
  { comment: "Export Item - Sugar" },
  { comment: "Export Item - Pulses" },
  { comment: "Export Item - Fertilizer" },
  { comment: "Export Item - Wood" },
  { comment: "Export Item - Ammunition" },
  { comment: "Export Item - Narcotics" },
  { comment: "Import Item - Ammunition" },
  { comment: "Import Item - Narcotics" },
  { comment: "Import Item - Lubricants" },
  { comment: "Import Item - Automotive" },
  { comment: "Import Item - Spare Parts" },
  { comment: "Import Item - Tyres" },
];
export const secondaryInspectionDepartments = [
  "BD",
  "ANF",
  "NPPD",
  "Detailed Inspection",
  "AQD",
  "FGS",
  "Customs",
];
export const filteryByArr = [
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "Last 7 days", value: "lastWeek" },
  { label: "Last 30 days", value: "lastMonth" },
  { label: "Custom", value: "custom" },
];
export const yearDate = [
  { label: "2020", value: "2020" },
  { label: "2021", value: "2021" },
  { label: "2022", value: "2022" },
  { label: "2023", value: "2023" },
  { label: "2024", value: "2024" },
  { label: "2025", value: "2025" },
  { label: "2026", value: "2026" },
  { label: "2027", value: "2027" },
  { label: "2028", value: "2028" },
  { label: "2029", value: "2029" },
  { label: "2030", value: "2030" },
  { label: "2031", value: "2031" },
  { label: "2032", value: "2032" },
  { label: "2033", value: "2033" },
  { label: "2034", value: "2034" },
  { label: "2035", value: "2035" },
  { label: "2036", value: "2036" },
  { label: "2037", value: "2037" },
  { label: "2038", value: "2038" },
  { label: "2039", value: "2039" },
  { label: "2040", value: "2040" },
  { label: "2041", value: "2041" },
  { label: "2042", value: "2042" },
];
export const allTerminalsList = [
  { id: 0, name: "Border Terminal" },
  { id: 1, name: "Off Dock Terminal" },
  { id: 2, name: "Dry Port Terminal" },
  { id: 3, name: "Dry Port Terminal Without Weboc" },
];

export const terminalTypeList = [
  { value: 0, name: "Border Terminal" },
  { value: 1, name: "Off Dock" },
  { value: 2, name: "Dry Port" },
  { value: 3, name: "HQ Dashboard" },
  { value: 4, name: "Dry Port without Weboc" },
];

export const indexStatusList = [{ name: "P" }, { name: "F" }];
